import apiClient from "./axios"

export const getAttendances = async (params = {}) => {
  const { data } = await apiClient.get("/attendance", { params })
  return data
}

export const getTodayAttendance = async () => {
  const { data } = await apiClient.get("/attendance/today")
  return data
}

export const checkInAttendance = async payload => {
  const { data } = await apiClient.post("/attendance/check-in", {
    ...payload,
    source: "web",
  })
  return data
}

export const checkOutAttendance = async payload => {
  const { data } = await apiClient.post("/attendance/check-out", {
    ...payload,
    source: "web",
  })
  return data
}

export const getMyAttendanceHistory = async (params = {}) => {
  const { data } = await apiClient.get("/attendance/my-history", { params })
  return data
}

export const createAttendance = async payload => {
  const { data } = await apiClient.post("/attendance", payload)
  return data
}

export const editAttendance = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/attendance/${id}`, payload)
  return data
}

export const deleteAttendance = async id => {
  const { data } = await apiClient.delete(`/attendance/${id}`)
  return data
}

export const getDailyAttendanceSummary = async (params = {}) => {
  const { data } = await apiClient.get("/attendance/summary/daily", { params })
  return data
}

export const getDailySummaryEmployees = async (params = {}) => {
  const { data } = await apiClient.get("/attendance/summary/daily/employees", { params })
  return data
}

export const getAttendanceSettings = async () => {
  const { data } = await apiClient.get("/attendance/settings")
  return data
}

export const updateAttendanceSettings = async payload => {
  const { data } = await apiClient.put("/attendance/settings", payload)
  return data
}
